// @ts-check
import { createApp } from 'vue'
import App from './App.vue'

const linkListApiUrl = JSON.parse(document.getElementById('app')?.dataset.linkListApiUrl ?? '')

createApp(App, {
  linkListApiUrl: linkListApiUrl,
}).mount('#app')
